export const iconFontAwesomeHumanitarianSatelliteDish = (
	<i className="fa-solid fa-satellite-dish"></i>
);
